/**
 * ThemeContext – Solid.js
 * 
 * Theme-Management (Dark/Light Mode)
 */
import { createContext, useContext, onMount, type JSX } from 'solid-js';

type Theme = 'light' | 'dark';

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

const defaultTheme: ThemeContextType = {
  theme: 'dark',
  toggleTheme: () => {},
  setTheme: () => {},
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  return context ?? defaultTheme;
};

interface ThemeProviderProps {
  children: JSX.Element;
}

export function ThemeProvider(props: ThemeProviderProps) {
  // Immer Dark Mode
  const theme: Theme = 'dark';

  /**
   * Theme auf HTML-Element anwenden
   */
  onMount(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  });

  const toggleTheme = (): void => {
    // Keine Funktion - immer Dark Mode
  };

  const setTheme = (_newTheme: Theme): void => {
    // Keine Funktion - immer Dark Mode
  };

  const value: ThemeContextType = {
    theme,
    toggleTheme,
    setTheme,
  };

  return <ThemeContext.Provider value={value}>{props.children}</ThemeContext.Provider>;
}
